import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { signUp } from '../../services/supabase';
import RegisterForm from '../../components/forms/RegisterForm';
import '../../styles/components/layout.css';

const RegisterPage = () => {
    const navigate = useNavigate();
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (formData) => {
        setError('');
        setSuccess(false);
        setLoading(true);

        try {
            // Log detalhado dos dados do formulário
            console.log(" Iniciando tentativa de cadastro com os seguintes dados:", {
                ...formData,
                password: '[SENHA_OCULTADA]' // Por segurança, não logamos a senha
            });

            const { user, error: signUpError, status } = await signUp(formData);

            // Log detalhado da resposta
            console.log(" Resposta da função signUp:", { 
                sucesso: !signUpError && !!user && status === 'SUCCESS',
                usuario: user ? {
                    id: user.id,
                    email: user.email,
                    nome: user.user_metadata?.full_name
                } : null,
                erro: signUpError?.message,
                status 
            });
            
            // Verifica todas as condições de erro possíveis
            if (signUpError || !user || status !== 'SUCCESS') {
                console.error(" Erro detectado no cadastro:", {
                    mensagem: signUpError?.message,
                    tipo: status,
                    detalhes: signUpError
                });

                setError(signUpError?.message || 'Erro ao criar conta. Tente novamente.');
                setSuccess(false);
                setLoading(false);
                return;
            }

            // Log de sucesso com detalhes do usuário
            console.log(" Cadastro realizado com sucesso!", {
                id: user.id,
                email: user.email,
                nome: user.user_metadata?.full_name,
                status
            });

            setSuccess(true);

            // Aguarda 5 segundos antes de redirecionar
            console.log(" Aguardando 5 segundos para redirecionamento...");
            setTimeout(() => {
                console.log(" Redirecionando para a página inicial...");
                navigate('/');
            }, 5000);

        } catch (err) {
            // Log detalhado do erro inesperado
            console.error(" Erro inesperado durante o cadastro:", {
                mensagem: err.message,
                stack: err.stack,
                detalhes: err
            });

            setError('Erro inesperado ao criar conta. Por favor, tente novamente.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-background flex flex-col items-center justify-center p-4">
            <img src="/assets/images/logo.png" alt="Alexander Logo" className="w-48 mb-8" />
            
            <div className="w-full max-w-md bg-white rounded-lg shadow-lg p-8">
                <div className="text-center mb-8">
                    <h2 className="text-3xl font-bold text-gray-900 mb-2">
                        Crie sua conta
                    </h2>
                    <p className="text-gray-600">
                        Já tem uma conta?{' '}
                        <Link to="/" className="text-accent hover:text-accent-dark font-medium transition-colors">
                            Faça login
                        </Link>
                    </p>
                </div>

                {success ? (
                    <div className="bg-success/10 text-success p-4 rounded-md text-center">
                        <p className="font-medium mb-2">Conta criada com sucesso!</p>
                        <p className="text-sm">Redirecionando para a página de login em 5 segundos...</p>
                    </div>
                ) : (
                    <>
                        {error && (
                            <div className="bg-red-50 text-error text-sm p-3 rounded-md mb-6">
                                {error}
                            </div>
                        )}
                        <RegisterForm onSubmit={handleSubmit} loading={loading} />
                    </>
                )}
            </div>
        </div>
    );
};

export default RegisterPage;
